import { useOutletContext } from 'react-router-dom';
import { ContractorList } from '@/components/contractors/ContractorList';
import type { AppShellContext } from '@/components/layout/AppShell';

export function ContractorsPage() {
  const { nip, companyName } = useOutletContext<AppShellContext>();
  return <ContractorList companyNip={nip} companyName={companyName} />;
}
